import { createContext, useContext, useState } from 'react';
import PropTypes from 'prop-types';

const UserContext = createContext();

export const UserProvider = ({ children }) => {
    const [users, setUsers] = useState([]);
    const [selectedUser, setSelectedUser] = useState({});
    const [user, setUser] = useState({
      id_utilisateur_gexonline: null,
      nom: '',
      prenom: '',
      id_utilisateur_gexpertise:null,
      password: '',
      email: '',
      entreprise:'',
      tel_fixe: '',
      archive: false,
      preference_vue:'carte',
      tel_mobile:'',
      photo:'',
      civilite:'',
      intitule_poste:'',
      date_password_changed:'',
      date_finalisation_enregistrement:'',
      token_odoo:'',
      lastseenconexin:'',
      id_type_fonction:'',
      id_secteur_activite:'',
      is_gex_memeber:''     
      
    });
  
    const setUserAttributes = (attributes) => {
      // Merge the new attributes with the existing ones
      setUser((prevUser) => ({ ...prevUser, ...attributes }));
      
    };
    const setUserList = (attribute) => {
 
      setUsers(attribute);
      
    };
  
    return (
      <UserContext.Provider value={{ users,  user, setUserAttributes, setUserList , selectedUser , setSelectedUser }}>
        {children}
      </UserContext.Provider>
    );
  };
  UserProvider.propTypes={
        children: PropTypes.node.isRequired
      }
    
  export const useUser = () => {
    return useContext(UserContext);
  };